module.exports = __webpack_public_path__ + "static/img/feature_3.aa6bec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/feature_3.png
// module id = VW1B
// module chunks = 0